// This file was automatically generated from print.cardiacOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.cardiacOrder');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.print.order');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.cardiacOrder.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.headerInfoOrders(opt_data, output);
  output.append('<div class="orderDetailsContainer preserve"><table class="w100"><tr><td class="pr10">');
  el8.template.print.order.testsSection(opt_data, output);
  el8.template.print.order.section({title: 'Reason for Exam', text: opt_data.order.clinicalReason}, output);
  el8.template.print.order.section({title: 'Beta Blockers Patient Is On', text: opt_data.order.medications}, output);
  el8.template.print.order.section({title: 'Notes/Instructions to Center', text: opt_data.order.testCenterNotes}, output);
  el8.template.print.order.ccsSection(opt_data, output);
  el8.template.print.order.section({title: 'Note to Patient', text: opt_data.order.patientInstructions}, output);
  output.append('</td><td class="rightColumn">');
  el8.template.print.order.dxsSectionBullets(opt_data, output);
  output.append('</td></tr></table></div>');
  el8.template.print.signature({esignatureUrl: opt_data.order.esignatureUrl, isOrder: true, localFsPath: opt_data.localFsPath, signPhysician: opt_data.order.signPhysician, signPhysicianIdentifiers: opt_data.order.signPhysicianIdentifiers, signDate: opt_data.order.signDate}, output);
  if (opt_data.cardiacHasNuclear) {
    el8.template.print.cardiacOrder.patientInstrNuclear(null, output);
  }
  if (opt_data.cardiacHasNoPrep) {
    el8.template.print.cardiacOrder.patientInstrNoPrep(null, output);
  }
  if (opt_data.cardiacHasTreadmill) {
    el8.template.print.cardiacOrder.patientInstrTreadmill(null, output);
  }
  if (opt_data.cardiacHasUltrasound) {
    el8.template.print.cardiacOrder.patientInstrUltrasound(null, output);
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.cardiacOrder.patientInstrNuclear = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="printTestCenterInfo"><div class="emphasis">Test Prep Instructions for Patient</div><div class="p5"><div class="mt10 normalText"><ul class="fieldSavedList"><li class="fieldSavedBullet">Fast from midnight if your test is in the morning. Fast from 9:00am if you test is in the afternoon.</li><li class="fieldSavedBullet">Bring in a list of your medications and dosages.</li><li class="fieldSavedBullet">Bring food for your 30-minute break.  This should be a fatty food and a carbonated drink.</li><li class="fieldSavedBullet"><span class="el8Bold">No caffeine 24 hours prior to the test (coffee, test, soft drinks or chocolate).</span></li><li class="fieldSavedBullet">Wear comfortable clothing. (A top you can easily take off, and shoes you can exercise in.)</li><li class="fieldSavedBullet">No metal buttons or metal designs on top.</li></ul><p class="">If you need to cancel your test, please call before 2:00pm the day prior as the medication is ordered the day before.  Failure to cancel will result in a charge.</p></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.cardiacOrder.patientInstrNoPrep = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="printTestCenterInfo"><div class="emphasis">Test Prep Instructions for Patient</div><div class="p5"><div class="mt10 normalText"><ul class="fieldSavedList"><li class="fieldSavedBullet">Please drink plenty of water prior to test.</li></ul></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.cardiacOrder.patientInstrTreadmill = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="printTestCenterInfo"><div class="emphasis">Test Prep Instructions for Patient</div><div class="p5"><div class="mt10 normalText"><ul class="fieldSavedList "><li class="fieldSavedBullet">Nothing to eat three (3) hours before the test.</li><li class="fieldSavedBullet"><span class="el8Bold">It is OK to drink water.</span></li><li class="fieldSavedBullet">No caffeine products for three (3) hours prior to test.</li><li class="fieldSavedBullet"><span class="el8Bold">Wear comfortable clothing and walking shoes.</span></li><li class="fieldSavedBullet">No smoking one (1) hour prior to test.</li></ul></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.cardiacOrder.patientInstrUltrasound = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="printTestCenterInfo"><div class="emphasis">Test Prep Instructions for Patient</div><div class="p5"><div class="mt10 normalText"><ul class="fieldSavedList"><li class="fieldSavedBullet">No eating for twelve (12) hours.</li><li class="fieldSavedBullet"><span class="el8Bold">It is OK to drink water.</span></li><li class="fieldSavedBullet">No Smoking.</li><li class="fieldSavedBullet">No gum on the day of the test.</li></ul></div></div></div>');
  if (!opt_sb) return output.toString();
};
